import { __assign } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import SvgIcon from '../SvgIcon';

var DoneSmall = function DoneSmall(props) {
  return _jsx(SvgIcon, __assign({}, props, {
    children: _jsx("path", {
      d: "M9.99512 14.95L6.99878 11.8L6 12.85L9.99512 17.05L18.5561 8.05L17.5573 7L9.99512 14.95Z"
    })
  }));
};

export default DoneSmall;